import prjctImg1 from "../assets/prjct.png";
import prjctImg2 from "../assets/prjct2.png";
import prjctImg3 from "../assets/book_keeper.JPG";
import prjctImg4 from "../assets/car_service.JPG";

const WorkCardData = [
     {
        imgsrc: prjctImg1,
        title: "Todolist App",
        text: "Keep track of your daily tasks and stay organized with this user-friendly Todo List app built with React. Plus, the intuitive design makes adding and editing tasks a breeze. Try it out today and take control of your productivity!",
        view:"https://simplereacttodoapp.netlify.app/",
        source:"https://github.com/partha2w/ReactTodo.git"
     },
     {
      imgsrc: prjctImg2, 
      title: "Simple Blog Page",
      text: "A simple blog page built with Express.js and Node.js to demonstrate backend skills in REST API handling. The project focuses on basic CRUD operations without using a database or authentication, showcasing core Express server setup and routing.",
      view: "https://blog-page-server-1vxe.onrender.com/",
      source: "https://github.com/partha2w/Blog-Page"
     },
     {
      imgsrc: prjctImg3, 
      title: "Book-keeper application",
      text: "The Book keeper application allows users to manage their personal library by uploading details of books they have read or are currently reading. Key features include sorting and searching functionality to organize and retrieve book information efficiently.",
      view: "http://localhost:3000/",
      source: "https://github.com/partha2w/Book_keeper.git"
     },
     {
      imgsrc: prjctImg4, 
      title: "Car Servicing",
      text: "The Car Servicing Center Web Application is a user-friendly platform designed to streamline vehicle maintenance bookings. Built with a responsive frontend, this project focuses on delivering a seamless user experience for both customers and service providers.",
      view: "https://partha2w.github.io/Car_service/",
      source: "https://github.com/partha2w/Car_service.git"
     }
];

export default WorkCardData;